import { useTextStore } from '@/stores/textsStore';

/**
 * Composable for handling text keys with fallback to hardcoded text
 * 
 * Key naming convention: {page/feature}.{component}.{action}
 * Example: directdeposit.accountcard.button.edit
 */
export function useText() {
    const textStore = useTextStore();

    /**
     * Get text by key with fallback to default text
     * @param key - Text key following the convention {page/feature}.{component}.{action}
     * @param fallbackText - Default text to display if key is not found
     * @returns The text from API or fallback text
     */
    const getText = (key: string, fallbackText: string): string => {
        return textStore.getText(key, fallbackText);
    };

    return {
        getText
    };
}